// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1uVFW","detailsBorder":"styles_detailsBorder__1tE4S"};